let currentDate  = new Date();
let currentMonth = currentDate.getMonth() + 1;

export const currentSeason = (currentMonth < 9) ? {
    start: new Date('09/1/' + (currentDate.getFullYear() - 1)),
    end: new Date('08/31/' + (currentDate.getFullYear()))
} : {
    start: new Date('09/1/' + (currentDate.getFullYear())),
    end: new Date('08/31/' + (currentDate.getFullYear() + 1))
}

// get the year offset (if any) between start and end dates
export function getYearOffset (start, end) {
    let startMonth = new Date(start).getMonth() + 1
    let endMonth   = new Date(end).getMonth() + 1
    let offset     = {
        start: 0,
        end: 0,
    }

    if (startMonth >= 8 && startMonth <= 12 && endMonth <= 8 && endMonth >= 1) {
        if (currentMonth >= 1 && currentMonth <= 7) {
            offset.start = -1
            offset.end   = 0
        } else if (currentMonth >= 8 && currentMonth <= 12) {
            offset.start = 0
            offset.end   = 1
        }
    } else if (startMonth >= 9 && startMonth <= 12 && endMonth >= 9 && endMonth <= 12) {
        if (currentMonth >= 1 && currentMonth <= 8) {
            offset.start = -1
            offset.end   = -1
        } else if (currentMonth >= 9 && currentMonth <= 12) {
            offset.start = 0
            offset.end   = 0
        }
    } else if (startMonth >= 1 && startMonth <= 8 && endMonth >= 1 && endMonth <= 8) {
        if (currentMonth >= 1 && currentMonth <= 8) {
            offset.start = 0
            offset.end   = 0
        } else if (currentMonth >= 9 && currentMonth <= 12) {
            offset.start = 1
            offset.end   = 1
        }
    }

    return offset
}

// HELPERS

// Create a list of day and monthnames.
export const weekdays = [
           "Sunday", "Monday", "Tuesday",
           "Wednesday", "Thursday", "Friday",
           "Saturday"
       ],
             months   = [
                 "January", "February", "March",
                 "April", "May", "June", "July",
                 "August", "September", "October",
                 "November", "December"
             ];

// Append a suffix to dates.
// Example: 23 => 23rd, 1 => 1st.
export function nth (d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}

// Create a string representation of the date.
export function formatDate (date) {
    return months[date.getMonth()] + " " + date.getDate() + nth(date.getDate())
}

function padNumber (number, size) {
    let padded = number + ''
    while (padded.length < size) padded = "0" + padded
    return padded
}

// Create a string representation of the date.
export function convertTimestampToMonthDay (timestamp) {
    let date = new Date(+timestamp)
    return padNumber(date.getMonth() + 1, 2) + '/' + date.getDate()
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/utils/season.js
// module id = 192
// module chunks = 0